import React, { Component } from 'react'
import { ThemeProvider } from 'emotion-theming'
import MediaQuery from 'react-responsive'
import { ProyugaLogoWhiteFooter } from '../../Icons'
import IcCall from '../../Icons/IcCall'
import IcMissedCall from '../../Icons/IcMissedCall'
import IcWhatsApp from '../../Icons/IcWhatsApp'
import IcPostOffice from '../../Icons/IcPostOffice'
import defaulttheme from '../../../constants/themeConstants'
import {
  RobotoLightMeduimSoft,
  RobotoThickMedium
} from '../../Text/styledComponents'
import Helmet from 'react-helmet'
import ResponsiveContainer from '../../core/ResponsiveContainer'
import { MAIL_TO_PROYUGA_LINK } from '../../../constants/AppConstants'
import {
  Logo,
  InputDiv,
  EmailInput,
  Button,
  PageLink,
  QuickLinks,
  SocialReach,
  CopyRight,
  AddressHeading,
  AddressLine,
  AddressLineInfo,
  AddressLineInfo2,
  AddressLineDescription,
  MailAddressLine,
  AddressLineContainer,
  AddressSection,
  FooterDesktop,
  FooterMobile,
  FooterSection,
  NewsLetterSection,
  ReachItem,
  ReachItemGroup,
  ReachUsSection,
  ReachAndAddressSection,
  ReachUsHeading,
  MobileReachUsHeading,
  NewsLetterSubHeading,
  NewsLetterHeading,
  ProyugaFooterLogo,
  FBIcon,
  TwitterIcon,
  InstagramIcon,
  YoutubeIcon,
  SocialIconsContainer,
  MobileMailAddressLine,
  PageLinksContainer,
  SectionsContainer,
  LinksSectionsContainer,
  LogoQuickLinksSection,
  EmailError,
  EmailSuccess
} from './styledComponents'
import { submitForm } from '../../../utils/forms'

const schemaOrgJSONLD = [
  {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    url: 'https://proyuga.tech',
    '@id': 'https://proyuga.tech/#organization',
    name: 'ProYuga',
    description:
      'Developing transformative products in Virtual, Augmented and Mixed reality. We develop our own products, help others to develop their own products and offer development services to organizations. Our first product is iB Cricket, a new format of cricket, a vSport(eSport in Virtual Reality)',
    // logo: 'https://proyuga.tech/$Your Logo Image/Link Here$',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Mumbai',
      addressRegion: 'Maharashtra',
      postalCode: '400072',
      streetAddress: '1609, Lodha Supremus, Powai'
    },
    email: 'info@proyuga.tech',
    telephone: '8008858585',
    brand: {
      '@type': 'Brand',
      name: 'iB Cricket',
      url: 'https://ib.cricket',
      // logo:
      //   'https://ib.cricket/$Your Image or Logo Link of that Brand$ - iBC Logo',
      alternateName: 'iBC',
      description:
        "iB Cricket is a new format of cricket. It is a vSport (eSport in Virtual Reality) offering the world's most immersive VR Cricket experience. Play cricket in international stadiums, compete globally, build your iBC career right from your home or iBC Arcades.",
      sameAs: [
        'https://www.facebook.com/iB-Cricket-290881654776081',
        'https://twitter.com/ib_cricket',
        'https://instagram.com/ibcricket'
      ]
    }
  }
]

const ReachUs = [
  {
    mail: 'info@proyuga.tech',
    tollfreenumber: '1800-103-9141',
    mailToLink: MAIL_TO_PROYUGA_LINK,
    tollfreeText: '(toll free)',
  }
]
const Address = [
  {
    Addressline1: '1609, Lodha Supremus,',
    Addressline2: 'Powai, Mumbai, Maharashtra, 400072'
  }
]
// const mail = 'info@proyuga.tech'
// const phonenumber = '+91 8008 71 71 71'
// const tollfreenumber = '1800-103-9141'
// const missedcallnumber = '+91 8184 92 22 21'

class FooterV2 extends Component {
  state = {
    email: '',
    isValidEmail: true,
    isSubmitted: false
  }
  onChange = e => {
    this.setState({
      email: e.target.value,
      isValidEmail: true
    })
  }
  onSuccess = () => {
    this.setState({
      email: '',
      isValidEmail: true,
      isSubmitted: true
    })
  }

  handleSubmit = () => {
    const emailId = this.state.email.trim()
    let isValidEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,64}$/i.test(
      emailId
    )
    if (isValidEmail) {
      const values = {
        email: emailId
      }
      submitForm(values, 2, 'subscribersproyuga', this.onSuccess)
    } else {
      this.setState({
        isValidEmail: false,
        isSubmitted: false
      })
    }
  }

  isMobileDevice = () => {
    let isMobile = true
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      if (window.innerWidth > 767) {
        isMobile = false
      }
    }
    return isMobile
  }

  render() {
    const { isHome } = this.props

    let { email, isSubmitted, isValidEmail } = this.state
    const isMobile = this.isMobileDevice()

    const TotalReachUs = (
      <ReachUsSection>
        <ReachItemGroup>
          <ReachItem>
            <IcPostOffice />
            <MailAddressLine href={ReachUs[0].mailToLink}>
              {ReachUs[0].mail}
            </MailAddressLine>
          </ReachItem>
        </ReachItemGroup>
        <ReachItemGroup>
          <ReachItem>
            <IcCall />
            <AddressLine>{ReachUs[0].tollfreenumber}</AddressLine>
            <AddressLineInfo>{ReachUs[0].tollfreeText}</AddressLineInfo>
          </ReachItem>
        </ReachItemGroup>
      </ReachUsSection>
    )

    const TotalMobileReachUs = (
      <ReachUsSection>
        <ReachItem>
          <IcPostOffice />
          <MobileMailAddressLine href={ReachUs[0].mailToLink} target="_blank">
            {ReachUs[0].mail}
          </MobileMailAddressLine>
        </ReachItem>
        <ReachItem>
          <IcCall />
          <AddressLine>
            {ReachUs[0].tollfreenumber} {ReachUs[0].tollfreeText}
          </AddressLine>
        </ReachItem>
      </ReachUsSection>
    )

    const TotalAddress = (
      <AddressSection>
        <AddressLineDescription>
          {Address[0].Addressline1}
        </AddressLineDescription>
        <AddressLineDescription>
          {Address[0].Addressline2}
        </AddressLineDescription>
      </AddressSection>
    )

    const TotalQuickLinks = (
      <QuickLinks>
        <PageLinksContainer>
          <PageLink href="/">Home</PageLink>
          <PageLink href="/#ibCricketSection">iB Cricket</PageLink>
        </PageLinksContainer>
        <PageLinksContainer>
          <PageLink href="/team">Team</PageLink>
          <PageLink href="/careers">Careers</PageLink>
          <PageLink href="/#our-services">Our Services</PageLink>
        </PageLinksContainer>
      </QuickLinks>
    )

    const CopyRightDiv = (
      <CopyRight>© 2021 ProYuga. All rights reserved</CopyRight>
    )
    const SocialIcons = (
      <SocialIconsContainer>
        <FBIcon />
        <TwitterIcon />
        <YoutubeIcon />
        <InstagramIcon />
      </SocialIconsContainer>
    )

    const ContactUsEmailBlock = (
      <InputDiv>
        <EmailInput
          onChange={this.onChange}
          value={email}
          placeholder={isMobile ? 'E-mail address' : 'Enter email address'}
        />
      </InputDiv>
    )

    return (
      <ThemeProvider theme={defaulttheme}>
        <FooterSection id="contactUsSection">
          <MediaQuery query="(max-device-width: 767px)">
            <ResponsiveContainer>
              <FooterMobile>
                <Logo>
                  <ProyugaFooterLogo
                    src="/assets/images/proyuga-logo-white.png"
                    alt="proyuga logo"
                  />
                  {/* SOCIAL ICONS */}
                  {/* {SocialIcons} */}
                </Logo>

                <NewsLetterHeading>Join our newsletter!</NewsLetterHeading>
                <NewsLetterSubHeading>
                  Receive important updates
                </NewsLetterSubHeading>
                {ContactUsEmailBlock}
                {!isValidEmail && (
                  <EmailError> Invalid Email Address </EmailError>
                )}
                {isSubmitted && (
                  <EmailSuccess>
                    {' '}
                    You have successfully subscribed!{' '}
                  </EmailSuccess>
                )}

                <Button onClick={this.handleSubmit}>
                  <RobotoThickMedium>SUBSCRIBE</RobotoThickMedium>
                </Button>

                <SectionsContainer>
                  <LinksSectionsContainer>
                    {TotalQuickLinks}
                    <MobileReachUsHeading>Reach Us</MobileReachUsHeading>
                    {TotalMobileReachUs}
                    <AddressHeading>Address</AddressHeading>
                    {TotalAddress}
                  </LinksSectionsContainer>
                </SectionsContainer>

                {CopyRightDiv}
              </FooterMobile>
            </ResponsiveContainer>
          </MediaQuery>
          <MediaQuery query="(min-device-width: 768px)">
            <ResponsiveContainer>
              <FooterDesktop>
                <LogoQuickLinksSection>
                  <Logo>
                    <ProyugaFooterLogo
                      src="/assets/images/proyuga-logo-white.png"
                      alt="proyuga logo"
                    />
                    {/* SOCIAL ICONS */}
                    {/* {SocialIcons} */}
                  </Logo>
                </LogoQuickLinksSection>
                {TotalQuickLinks}
                <ReachAndAddressSection>
                  <ReachUsHeading>Reach Us</ReachUsHeading>
                  {TotalReachUs}
                  <AddressHeading>Address</AddressHeading>
                  {TotalAddress}
                </ReachAndAddressSection>
                <NewsLetterSection>
                  <NewsLetterHeading>Join our newsletter!</NewsLetterHeading>
                  <NewsLetterSubHeading>
                    Receive important updates
                  </NewsLetterSubHeading>
                  {ContactUsEmailBlock}
                  {!isValidEmail && (
                    <EmailError> Invalid Email Address </EmailError>
                  )}
                  {isSubmitted && (
                    <EmailSuccess>
                      {' '}
                      You have successfully subscribed!{' '}
                    </EmailSuccess>
                  )}
                  <Button onClick={this.handleSubmit}>
                    <RobotoThickMedium>SUBSCRIBE</RobotoThickMedium>
                  </Button>
                </NewsLetterSection>
              </FooterDesktop>
              {CopyRightDiv}
            </ResponsiveContainer>
          </MediaQuery>
        </FooterSection>
      </ThemeProvider>
    )
  }
}

FooterV2.defaultProps = {
  isHome: false
}

export default FooterV2
